// Scroll-snap sliders: the layout and swiping are plain CSS (.slider-track), this only wires
// the arrows and marks the first slide in view so the styles can fade the ones after it.
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function initSlider(root) {
    const track = root.querySelector('.slider-track');
    if (!track || !track.children.length) {
        return;
    }

    const slides = Array.from(track.children);
    const prevButtons = root.querySelectorAll('.slider-prev');
    const nextButtons = root.querySelectorAll('.slider-next');

    const step = () => (slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth);

    const move = (direction) => {
        track.scrollBy({ left: direction * step(), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };

    let frame = 0;
    const update = () => {
        frame = 0;
        const maxScroll = track.scrollWidth - track.clientWidth;
        const current = Math.round(track.scrollLeft / step());

        prevButtons.forEach((button) => {
            button.disabled = track.scrollLeft <= 1;
        });
        nextButtons.forEach((button) => {
            button.disabled = track.scrollLeft >= maxScroll - 1;
        });
        slides.forEach((slide, index) => slide.classList.toggle('is-current', index === current));
    };
    const scheduleUpdate = () => {
        if (!frame) {
            frame = requestAnimationFrame(update);
        }
    };

    prevButtons.forEach((button) => button.addEventListener('click', () => move(-1)));
    nextButtons.forEach((button) => button.addEventListener('click', () => move(1)));
    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    new ResizeObserver(scheduleUpdate).observe(track);
    update();
}

document.querySelectorAll('.slider').forEach(initSlider);
